<div *ngIf="token && email">
    <form [formGroup]="resetPasswordForm" *ngIf="!isSubmitted">
        <mat-form-field appearance="outline" style="width: 100%;" color="primary">
            <mat-label>{{'auth.reset-password.password' | translate}}</mat-label>
            <input matInput name="password" [type]="hidePassword ? 'password' : 'text'"
                [formControl]="passwordFormControl" autocomplete="off" (focus)="onPasswordFocus()"
                (blur)="onPasswordBlur()">
            <mat-icon *ngIf="passwordFormControl.value" class="password-eye" matSuffix (click)="onHidePassword()"
                [color]="passwordEyeColour()">
                {{hidePassword ? 'visibility_off' : 'visibility'}}
            </mat-icon>
            <mat-error *ngIf="passwordFormControl.hasError('pattern') && !passwordFormControl.hasError('required')">
                {{'auth.reset-password.password-hint' | translate}}
            </mat-error>
            <mat-error *ngIf="passwordFormControl.hasError('required')">
                {{'common.field-required' | translate}}
            </mat-error>
        </mat-form-field>
        <mat-form-field appearance="outline" style="width: 100%;" color="primary">
            <mat-label>{{'auth.reset-password.confirm-password' | translate}}</mat-label>
            <input matInput name="password" [type]="hideConfirmPassword ? 'password' : 'text'"
                [formControl]="confirmPasswordFormControl" autocomplete="off" (focus)="onConfirmPasswordFocus()"
                (blur)="onConfirmPasswordBlur()" [errorStateMatcher]="passwordMatcher">
            <mat-icon *ngIf="confirmPasswordFormControl.value" class="password-eye" matSuffix
                (click)="onHideConfirmPassword()" [color]="confirmPasswordEyeColour()">
                {{hideConfirmPassword ? 'visibility_off' : 'visibility'}}
            </mat-icon>
            <mat-error *ngIf="resetPasswordForm.hasError('notSame')">
                {{'auth.reset-password.passwords-not-same' | translate}}
            </mat-error>
            <mat-error *ngIf="confirmPasswordFormControl.hasError('required')">
                {{'common.field-required' | translate}}
            </mat-error>
        </mat-form-field>
        <div class="form-button-row">
            <button mat-raised-button color="primary" (click)="setPassword()"
                [disabled]="resetPasswordForm.errors || passwordFormControl.errors || confirmPasswordFormControl.errors">
                {{'common.send' | translate}}
            </button>
        </div>
    </form>
    <div *ngIf="isSubmitted">
        <p>{{'auth.reset-password.password-processing' | translate}}</p>
        <p>{{'auth.reset-password.password-processing-email-info' | translate}}</p>
        <br/>
        <p><a (click)="onSignOut()">{{'auth.back-to-sign-in' | translate}}</a></p>
    </div>
</div>
<div *ngIf="token && !email">
    <a (click)="onSignOut()">{{'auth.back-to-sign-in' | translate}}</a>
</div>